import { createContext } from "react";

export const billingFilterOptions = (
  parentCompanyList,
  subCompanyList,
  cityList,
  defaultValues
) => [
  {
    id: 1,
    name: "parentCompanyName",
    label: "Company Name",
    placeholder: "Choose Company",
    options: parentCompanyList,
    defaultValues: defaultValues?.parentCompany || {},
  },
  {
    id: 2,
    name: "city",
    label: "City",
    placeholder: "Choose City",
    options: cityList,
    defaultValues: defaultValues?.cityValue || {},
  },
];

export const biillingTabs = [
  {
    label:"Bill To Company",
    value: "billToCompany"
  },
  {
    label:"Bill To Credit Card",
    value:"billToCreditCard"
  }
]

export const billingCompanyCardTabs = [
  {
    label:"All",
    value: "all"
  },
  {
    label:"Pending Approval",
    value:"pendingApproval"
  },
  {
    label:"Approve for charge",
    value:"approvalForCharge"
  },
  {
    label:"Dispute",
    value:"dispute"
  },
  {
    label:"Final Invoice",
    value:"charged"
  }
]

export const billingCreditCardTabs = [
  {
    label:"Final Invoice",
    value:"charged"
  }
]